export default __webpack_public_path__ + "static/media/icon-present.af87c3a8.svg";